module.exports = __webpack_public_path__ + "img/261.cfea116d.jpg";